import { ListItemText as MuiListItemText, ListItem as MuiListItem } from "@mui/material";
import styled from "@emotion/styled";

export const ListItem = styled(MuiListItem)({ padding: 4, width: 384 });

export const ListItemTextName = styled(MuiListItemText)({
  "& span": { fontSize: 16 },
});

export const ListItemTextSize = styled(MuiListItemText)({
  color: "#00000099",
  "& span": { fontSize: 16 },
});
